import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from "../dbconn";
import fetch from "isomorphic-fetch";
import {API_ROOT, IMAGE_ROOT, SUB_DOMAIN} from "../api-config";
import Modal from 'react-responsive-modal';
import Color from "color";
import i18n from "../i18n";
import axios from "axios";

class Startup extends Component{

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirectlogin: false,
            redirectmenu: false,
            redirect404:false

        };
    };


    componentWillMount() {

    }

    componentDidMount() {
        this.fetchStoreID();
    }

    fetchStoreID = () => {

        var url = API_ROOT + '/fetchstoreid?sub_domain=' + SUB_DOMAIN;

        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(storeData => {

                if (storeData.status == 1 && storeData.store_data.length > 0) {



                    localStorage.setItem('store_id', storeData.store_data[0].store_id);
                    localStorage.setItem('store_image', storeData.store_data[0].store_image);
                    localStorage.setItem('store_primary_color', storeData.store_data[0].store_primary_color);
                    localStorage.setItem("store_language", storeData.store_data[0].store_language);
                    var color = Color(storeData.store_data[0].store_primary_color).alpha(0.6).lighten(0.6);
                    localStorage.setItem('store_light_color', color.hex());
                    localStorage.setItem('store_secondary_color', storeData.store_data[0].store_secondary_color);
                    localStorage.setItem('store_button_color', storeData.store_data[0].store_button_color);
                    localStorage.setItem('store_name', storeData.store_data[0].store_name);
                    localStorage.setItem('store_address', storeData.store_data[0].store_address);
                    localStorage.setItem('store_city', storeData.store_data[0].store_city);
                    localStorage.setItem('store_state', storeData.store_data[0].store_state);
                    localStorage.setItem('store_zip', storeData.store_data[0].store_zip);
                    localStorage.setItem('store_phone', storeData.store_data[0].store_phone);
                    localStorage.setItem('store_email', storeData.store_data[0].store_email);
                    localStorage.setItem('store_delivery_range', storeData.store_data[0].store_delivery_range);
                    localStorage.setItem('store_latitude', storeData.store_data[0].store_latitude);
                    localStorage.setItem('store_longitude', storeData.store_data[0].store_longitude);
                    localStorage.setItem('merchant_id', storeData.store_data[0].merchant_id);
                    i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
                    });

                    localStorage.setItem("store_bypass_customer_signup_enabled",storeData.store_data[0].store_bypass_customer_signup_enabled);


                    var primaryColor = localStorage.getItem("store_primary_color");

                    if (primaryColor != null) {
                        document.documentElement.style.setProperty('--primaryColor', primaryColor);
                    }


                    var lightColor = localStorage.getItem("store_light_color");

                    if (lightColor != null) {
                        document.documentElement.style.setProperty('--lightColor', lightColor);
                    }

                    var secondaryColor = localStorage.getItem("store_secondary_color");


                    if (secondaryColor != null) {
                        document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
                    }
                    var buttonColor = localStorage.getItem("store_button_color");

                    if (buttonColor != null) {
                        document.documentElement.style.setProperty('--buttonColor', buttonColor);
                    }

                    if(storeData.store_data[0].store_bypass_customer_signup_enabled=="Y") {

                        var dbconn = new db();

                        dbconn.getAll().then(data => {

                            if (!data || data.length < 1) {
                                sessionStorage.setItem('guestFlag', 'Y');
                                this.setState({redirectmenu: true});
                            } else {
                                sessionStorage.setItem('guestFlag', 'N');
                                this.setState({redirectmenu: true});
                            }
                        });


                    }else{
                        sessionStorage.setItem('guestFlag', 'N');
                        this.setState({redirectlogin: true});
                    }


                } else {

                    this.setState({redirect404: true});
                }
            });
    };
    render() {
        if (this.state.redirect404) {
            return <Redirect to="/404"/>;
        }
        if (this.state.redirectlogin) {
            return <Redirect to="/login"/>;
        }
        if (this.state.redirectmenu) {
            return <Redirect to="/menu"/>;
        }

        return ('');
    }
}

export default Startup;


// WEBPACK FOOTER //
// ./src/view_components/startup.js